import React, { useState } from "react";
import { Platform, StatusBar, View } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { updateData } from "../../../../../services/Profile/profileService";
import { PROFILE_ROUTES } from "../../../../../navigation/routes";
import TopIconView from "../../../../Auth/components/TopIconView";
import TextView from "../../../../../components/CustomComponent/TextView";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import { Colors } from "../../../../../globalStyles/ColorConfig";
import BottomView from "../../../../../components/GlobalComponents/BottomView";
import OnBoardingIcons from "../../../../../assets/Icons/OnBoardingIcons";
import OptionRadio from "../../../components/OptionRadio";
import { handleBackButton } from "../../../components/BackButtonAlert";
import { useBackButtonHandler } from "../../../hooks/useBackHandler";
import { SafeAreaView } from "react-native-safe-area-context";

const OnBoardingGender = () => {
  const navigation = useNavigation();
  useBackButtonHandler(handleBackButton, [navigation]);

  const [gender, setGender] = useState<string | null>(null);

  const handlePress = (selectedGender: string) => {
    setGender(selectedGender);
  };

  async function nextButtoHandle() {
    if (gender !== null) {
      const updateUser = {
        gender: gender,
        steps: 3,
      };
      const response = await updateData(updateUser);
      navigation.navigate(PROFILE_ROUTES.MORE_DETAILS as never);
    }
  }

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: "#ffffff",
        paddingTop: 30,
      }}
    >
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
      <View
        style={{
          flex: 1,
          paddingHorizontal: 25,
          gap: 16,
        }}
      >
        <View
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TopIconView
            icon={<OnBoardingIcons.ProfileIconOnboarding />}
            currentScreen={3}
            totalScreens={10}
          />
        </View>
        <View
          style={{
            gap: 10,
          }}
        >
          <TextView
            title="Which gender best describe you?"
            textStyle={[
              GlobalStyles.heading3,
              {
                fontFamily: "EBGaramondSemiBold",
                fontSize: 34,
                lineHeight: 37,
                letterSpacing: -0.3,
              },
            ]}
          />
          <View>
            <OptionRadio
              label="Male"
              selected={gender === "Male"}
              onPress={() => handlePress("Male")}
            />
            <OptionRadio
              label="Female"
              selected={gender === "Female"}
              onPress={() => handlePress("Female")}
            />
            <OptionRadio
              label="Nonbinary"
              selected={gender === "Other"}
              onPress={() => handlePress("Other")}
            />
          </View>
        </View>
      </View>
      <BottomView
        enableTitle={false}
        onPress={nextButtoHandle}
        disableBtn={gender !== null}
        style={{ paddingBottom: 20 }}
      />
    </SafeAreaView>
  );
};

export default OnBoardingGender;
